import { createFileRoute } from "@tanstack/react-router"
import { AlertsTab } from "./_alerts-tab"

export const Route = createFileRoute("/settings/alerts")({
  component: AlertsTab,
})
